export default {
    Client: {
        TabChanged: 'clientTabChanged',
    },
    MembershipSubscription: {
        Purchased: 'membershipSubscriptionPurchased',
    },
};